import React from "react";
import { FormattedMessage, FormattedNumber } from "@/i18n/i18n-client";
import styled from "styled-components";
import { useStore } from "@/lib/storeData/StoreContext";
import { FlexRow } from "../../../../shared/globals";
import DisplayStarsRating from "./DisplayStarsRating";

interface ProductCardReviewsProps {
  totalReviews: number;
  averageRating: number;
}

const ProductCardReviews = ({
  totalReviews,
  averageRating,
}: ProductCardReviewsProps) => {
  const { storeReviewSettings: reviewsSettings } = useStore();
  return (
    <StyledFlexRow spacing="s" data-test="product-card-reviews-wrapper">
      {reviewsSettings?.showStars && (
        <DisplayStarsRating
          value={averageRating || 0}
          size={15}
          data-test="product-card-reviews-stars-rating"
        />
      )}
      {reviewsSettings?.showOverAllRating && (
        <StyledText bold data-test="product-card-reviews-average">
          <FormattedNumber value={parseFloat(averageRating.toFixed(1)) || 0} />
          {"/"}
          <FormattedNumber value={5} />
        </StyledText>
      )}
      {reviewsSettings?.showReviewsCount && (
        <StyledText data-test="product-card-reviews-count">
          <FormattedMessage
            defaultMessage="{reviewsCount, plural, =0 {0 reviews} one {1 review} two {# reviews} few {# reviews} many {# reviews} other {# reviews}}"
            id="4e0Z5E"
            values={{
              reviewsCount: totalReviews || 0,
            }}
          />
        </StyledText>
      )}
    </StyledFlexRow>
  );
};

const StyledFlexRow = styled(FlexRow)`
  margin-top: 15px;
  flex-wrap: wrap;
`;

const StyledText = styled.p<{ bold?: boolean }>`
  margin: 0;
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
`;

export default ProductCardReviews;
